import { FC } from 'react';
// State
import { useSelector } from 'react-redux';
// Selectors
import { selectFilteredDuplicates } from 'app/store/Cases/Cases.selectors';
// MaterialUI
import { Box } from '@mui/material';
// Components
import { Loader, Message } from 'app/components/Utilities';
// 
import DuplicatesClusterList from './DuplicatesClusterList';
// i18next
import { useTranslation } from 'react-i18next';

const DuplicatesCluster:FC = () => {
  const { t } = useTranslation();
  // State
  const filteredDuplicates = useSelector(selectFilteredDuplicates);

  if ( !filteredDuplicates ) return <Loader />;
  if ( !Object.keys(filteredDuplicates).length ) return <Message text={t('pages.duplicates.noData')} />;
  return (
    <Box id="scrollContainer" sx={{ overflowY: 'auto' }}>
      {Object.keys(filteredDuplicates).map((key, index:number) => (
        <Box
          key={`duplicate-cluster-item-${index}`}
          sx={{
            bgcolor: `${index%2 ? '#ededed' : 'transparent'}`,
            p: 4
          }}
        >
          <DuplicatesClusterList cluster={filteredDuplicates[key]} clusterKey={key} />
        </Box>
      ))}
    </Box>
  )
}

export default DuplicatesCluster;